import { RankGroupId } from '@/enums/rankGroupId';
import { Collapse } from '@mui/material';
import { useToggle } from '@starsoft/common/hooks';
import { memo, useEffect } from 'react';
import CollapseButton from './CollapseButton';
import CollapsedRanks from './CollapsedRanks';
import { RankGroupProps } from './props';
import styles from './styles.module.scss';

function RankGroup({ data, isLoading }: RankGroupProps) {
  const [open, toggle] = useToggle();

  function onMount() {
    if (!data || data?.id !== RankGroupId.Iron) {
      return;
    }

    toggle();
  }

  useEffect(onMount, [data, toggle]);

  return (
    <div className={styles.container}>
      <CollapseButton
        data={data}
        isOpen={open}
        toggle={toggle}
        isLoading={isLoading}
      />

      <Collapse in={open}>
        <CollapsedRanks
          ranks={
            data?.ranks?.sort(
              (a, b) => a?.experience?.toNumber() - b?.experience?.toNumber(),
            ) ?? []
          }
        />
      </Collapse>
    </div>
  );
}

export default memo(RankGroup);
